"use client";
import React from "react";
import Image, { StaticImageData } from "next/image";
 

interface Service {
  title: string;
  description: string;
  image: StaticImageData;
  altText: string;
}

interface ManageServicesProps {
  heading: string;
  subHeading: string;
  services: Service[];
}

const ManageServices: React.FC<ManageServicesProps> = ({ heading, subHeading, services }) => {
  return (
    <section className="custMargin">
      <div className="container">
        <h1 className="fw-bold fs-1 textHad text-center">{heading}</h1>
        <p className="fw-normal fs-5 textPara text-center">{subHeading}</p>
        <div className="row g-4 mt-2 justify-content-center">
          {services.map((service, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-6 col-12 d-flex">
              <div className="text-center card-body hvr-float">
                <Image
                  src={service.image}
                  className="img-fluid mb-3"
                  alt={service.altText}
                  width={70}
                  height={70}
                />
                <h4 className="fw-bold fs-6 textHad">{service.title}</h4>
                <p className="textPara fw-normal fs-6">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManageServices;
